import styled, { keyframes } from 'styled-components';

const skeleton = keyframes`
  0% {
    background-color: hsl(200, 20%, 80%);
  }
  100% {
    background-color: hsl(200, 20%, 95%);
  }
`;

export const Skeleton = styled.div<{ width?: number; height: number }>`
  width: ${({ width }) => (width ? `${width}px` : '100%')};
  height: ${({ height }) => `${height}px`};
  animation: ${skeleton} 1s linear infinite alternate;
`;
